import InfoSocioCertificatoView from "./InfoSocioCertificatoView";
import {getUtenteByIdApi} from "../../../../services/UtentiServices";
import {useContext, useEffect, useState} from "react";
import {LoaderContext} from "../../../../context/LoaderContext";

export default function InfoSocioCertificatoController({
                                                           certificato,
                                                       }) {

    const [socio, setSocio] = useState(null);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getSocio(idSocio) {
        startChiamata();

        const response = await getUtenteByIdApi(idSocio);
        setSocio(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (certificato) {
            getSocio(certificato.id_utente);
        }
    }, [certificato]);

    return (
        <InfoSocioCertificatoView
            socio={socio}
        />
    );
}